import { Box, Button, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface HomePageModule {
  id: string;
  name: string;
  label: string;
  description?: string;
}

interface HomePageProps {
  modules: HomePageModule[];
  onModuleClick: (module: HomePageModule) => void;
}

const GRID_SX = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
  gap: 4,
  mt: 8,
  maxWidth: 900,
  marginInline: 'auto',
} as const;

export default function HomePage({ modules, onModuleClick }: HomePageProps) {
  const { t } = useTranslation();

  return (
    <Box sx={{ p: 8, textAlign: 'center' }}>
      <Typography variant="h3">{t('home.title')}</Typography>
      <Typography color="textSecondary">{t('home.subtitle')}</Typography>

      {modules.length === 0 ? (
        <Typography color="textSecondary" sx={{ mt: 8 }}>
          {t('home.noModules')}
        </Typography>
      ) : (
        <Box sx={GRID_SX}>
          {modules.map((mod) => (
            <Paper
              key={mod.id}
              variant="outlined"
              sx={{ p: 6, textAlign: 'start', display: 'flex', flexDirection: 'column', gap: 4 }}
            >
              <Typography variant="h5">{mod.label}</Typography>
              {mod.description && <Typography sx={{ flexGrow: 1 }}>{mod.description}</Typography>}
              <Button sx={{ alignSelf: 'flex-start' }} onClick={() => onModuleClick(mod)}>
                {t('home.openModule')}
              </Button>
            </Paper>
          ))}
        </Box>
      )}
    </Box>
  );
}
